export default {
  productName: 'Nome do Produto',
  pay: 'PAGUE',
  payTokenLack: 'Consulta paga o simbolo necessária! Entre em contato conosco para obter ajuda',
  payTokenInvalid: 'Pagar o simbolo e pagar o canal Incompatibilidade! Entre em contato conosco para obter ajuda',
  noPayChannel: 'Nenhum canal de pagamento disponível',
  currencyMismatch: 'Nao pode proceder com uma cuerencia errada , por favor tente outro canal ou contacte nos.',
  networkError: 'rede de servidor não disponível, por favor tente mais tarde.',
  invokeTimeoutNotice: 'O resultado do pagamento ainda está em processo ... Verifique o estado do seu pedido e tente novamente mais tarde.',
  ok: 'OK',
  paymentMethodNotSupported: 'Este método de pagamento não é suportado, por favor tente outro metodo',
  enterCompleteInfo: 'Digite as informações completas.',
  enterCorrectInfo: 'Digite o XXX correto',
  sendOtpCode: 'ENVIAR',
  textOnairNext: 'A SEGUIR',
  voteCancel: 'CANCEL',
  paymentSuccessful: 'Pagamento com Sucesso',
  paymentSuccessfulDesc: 'pagamento. Seu pedido foi pago com sucesso. Por favor, clique em "OK" se você não for redirecionado dentro de 10s.',
  paymentFailed: 'Pagamento falhado',
  refresh: 'ATUALIZAR',
  orderIdEmpty: 'O ID do pedido está vazio, solicitação inválida. Entre em contato conosco para obter ajuda',
  waitingMessage: 'Processando o seu pagamento,porfavor aguarde por um momento',
  resultTimeoutNotice: 'Tempo limite da transação, ainda estamos processando seu pagamento e pode levar mais tempo. O resultado será atualizado imediatamente quando vier, obrigado por sua paciência.'
}
